export default __webpack_public_path__ + "static/media/monkey.c944f62f.png";